// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "main" + "." + "b0730392dad2b6e4f973" + ".css";
};